import { notFound } from '@tanstack/react-router';
import { z } from 'zod';

export const positiveIntParamSchema = z.coerce.number<number>().int().positive();

function parseIdParam(raw: string): number {
    const result = positiveIntParamSchema.safeParse(raw);
    if (!result.success) throw notFound();
    return result.data;
}

export const projectIdParams = {
    parse: (raw: { projectId: string }) => ({
        projectId: parseIdParam(raw.projectId),
    }),
    stringify: (params: { projectId: number }) => ({
        projectId: String(params.projectId),
    }),
};

export const projectAssetParams = {
    parse: (raw: { projectId: string; projectAssetId: string }) => ({
        projectId: parseIdParam(raw.projectId),
        projectAssetId: parseIdParam(raw.projectAssetId),
    }),
    stringify: (params: { projectId: number; projectAssetId: number }) => ({
        projectId: String(params.projectId),
        projectAssetId: String(params.projectAssetId),
    }),
};

export const statusReportParams = {
    parse: (raw: { statusReportId: string }) => ({
        statusReportId: parseIdParam(raw.statusReportId),
    }),
    stringify: (params: { statusReportId: number }) => ({
        statusReportId: String(params.statusReportId),
    }),
};
